import { Component } from 'react'
import PropTypes from 'prop-types'

import { SDKClientCommunicatorInterface } from '@cred/widget-sdk-client'

class ApplicationErrorBoundary extends Component {
  static getDerivedStateFromError(error) {
    return { error }
  }

  state = { error: undefined }

  componentDidCatch(error) {
    // eslint-disable-next-line
    console.error('Credible Partners Widget: Unhandled error', error)
    SDKClientCommunicatorInterface.sentMessage('onError')
  }

  render() {
    const { error } = this.state
    const { children } = this.props

    if (error) {
      return null
    }

    return children
  }
}

ApplicationErrorBoundary.propTypes = {
  children: PropTypes.element.isRequired,
}

export default ApplicationErrorBoundary
